import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { getHighwayLabel } from '../../../utils/lotStreetDisplay';
import {
  LOT_INFO_FIELD_ROW_SX,
  lotInfoFieldLabelLayoutSx,
  lotInfoFieldValueSx,
} from './formBlockUi';

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      textAlign: 'center',
      maxWidth: 280,
      whiteSpace: 'normal',
      fontSize: '12px',
      lineHeight: 1.4,
    },
  },
};

const LotRoadFrontTypeSection = ({ frontHighwayType = null }) => {
  const label = getHighwayLabel(frontHighwayType);
  const isEmpty = label === '—';

  return (
    <Box sx={LOT_INFO_FIELD_ROW_SX}>
      <Typography sx={lotInfoFieldLabelLayoutSx()}>
        Tipo de calle
      </Typography>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Tooltip
          title={isEmpty ? 'Sin datos de calles cercanas al frente.' : label}
          placement="top"
          arrow
          slotProps={TOOLTIP_SLOT_PROPS}
        >
          <Typography
            component="span"
            sx={{
              ...lotInfoFieldValueSx({ muted: isEmpty, noWrap: true }),
              maxWidth: '100%',
              textAlign: 'right',
              cursor: 'help',
            }}
          >
            {label}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default LotRoadFrontTypeSection;
